<template>
  <div class="plan-prices--wrap text-center text-lg-left">
    <div class="text-h5 text-lg-center px-4 py-lg-4">
      Mtl. Preis / User:
      <span class="font-weight-bold">
        {{ $formatPrice(pricePerUser, priceLocale) }}
      </span>
    </div>

    <div class="px-4 pb-4 text-h6 font-weight-regular font-exo flex-grow-1 d-flex flex-column text-center">
      <div v-if="additionalOptionsPrice > 0">
        Zusatzoptionen: {{ $formatPrice(additionalOptionsPrice, priceLocale) }}
      </div>

      <div>
        <template v-if="plan.termModel.payment_obligation_month === 12">
          <div class="font-weight-bold">
            Sie sparen
            {{ $formatPrice(yearlySavings, priceLocale) }}
            jährlich
          </div>
          <div class="text-subtitle-2 font-weight-light mt-n1">
            gegenüber Laufzeit 1 Monat
          </div>

          <v-btn
            variant="outlined"
            size="small"
            class="mt-4"
            @click="totalPriceVisible = !totalPriceVisible"
          >
            {{ totalPriceVisible ? 'Gesamtpreis ausblenden' : 'Gesamtpreis anzeigen' }}
          </v-btn>

          <v-expand-transition>
            <div v-if="totalPriceVisible">
              <div class="pt-3">
                Gesamt: {{ $formatPrice(isYearlyPlan ? monthlyPrice * 12 : monthlyPrice, priceLocale) }}

                {{ isYearlyPlan ? 'jährlich' : 'mtl.' }}

                <div v-if="isYearlyPlan" class="mt-n2">
                  entspricht {{ $formatPrice(monthlyPrice, priceLocale) }} mtl.
                </div>

                <div class="text-subtitle-2 mt-n1 font-weight-light">
                  zzgl. gesetzl. MwSt
                </div>
              </div>
            </div>
          </v-expand-transition>
        </template>
        <template v-else>
          Gesamt: {{ $formatPrice(isYearlyPlan ? monthlyPrice * 12 : monthlyPrice, priceLocale) }}

          {{ isYearlyPlan ? 'jährlich' : 'mtl.' }}

          <div class="text-subtitle-2 mt-n1 font-weight-light">
            zzgl. gesetzl. MwSt
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'plan-prices',

  props: {
    enteredUsers: {
      type: Number,
      default: 0,
    },

    pricingOptions: {
      type: Array,
      default: () => ([]),
    },

    priceLocale: {
      type: Object,
      default: null,
    },

    monthlyModel: {
      type: String,
      default: null,
    },

    additionalOptionsPrice: {
      type: Number,
      default: 0,
    },

    plan: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      totalPriceVisible: false,
    }
  },

  computed: {
    /**
     * @returns {boolean}
     */
    isYearlyPlan () {
      return this.plan?.termModel.payment_period_month === 12
    },

    /**
     * @returns {number}
     */
    pricePerUser () {
      return this.getPriceStepForUserAmount(this.plan)?.price
    },

    /**
     * monthlyPrice
     *
     * @returns {number}
     */
    monthlyPrice () {
      return this.pricePerUser * this.enteredUsers + this.additionalOptionsPrice
    },

    /**
     * @returns {number|null}
     */
    yearlySavings () {
      const stepForChosenModel = this.getPriceStepForUserAmount(this.plan)
      const stepForMonthlyModel = this.getPriceStepForUserAmount(this.pricingOptions.find(({ modelId }) => modelId === this.monthlyModel))

      return stepForChosenModel && stepForMonthlyModel
        ? (stepForMonthlyModel.price - stepForChosenModel.price) * this.enteredUsers * 12
        : null
    },
  },

  methods: {
    /**
     * Every tariff has multiple prices based on the entered users.
     *
     * @returns {object|null}
     */
    getPriceStepForUserAmount (plan) {
      return plan?.priceSteps
        ? plan?.priceSteps.find(({ min, max }) => this.enteredUsers >= min && this.enteredUsers <= max)
        : null
    },
  }
}
</script>
